import React, { Component } from 'react';
import './Review.css';
import VersCard from '../../components/VerseCard/VerseCard';
import TopBar from '../../components/TopBar/TopBar';
import RaisedButton from 'material-ui/RaisedButton';
import Quran from '../../quran/Quran';

class Review extends Component {

  constructor(props) {
    super(props)
    this.state = {
      viewableRange: {
        start: 0,
        length: 40,
        threshold: 100,
        origin: 0
      }
    }
  }

  componentDidMount() {
    // this.checkInterval = window.setInterval(() => {
    //   let scrollRoot = document.querySelector('.review__main')
    //   if (scrollRoot == null) return

    //   const scrollThreshold = 50
    //   if (scrollRoot.scrollTop < scrollThreshold) {
    //     this.loadBefore()
    //   }
    //   else if (scrollRoot.scrollHeight - scrollRoot.offsetHeight - scrollThreshold > scrollRoot.scrollTop) {
    //     this.loadAfter()
    //   }
    // }, 500)
  }

  componentWillUnmount() {
    // window.clearInterval(this.checkInterval)
  }

  loadBefore = () => {
    const count = 20

    let scrollRoot = document.querySelector('.review__main')
    let firstCard = scrollRoot.querySelector('.verse-card')
    let offsetTop = firstCard.offsetTop - scrollRoot.scrollTop

    this.setState((state) => {
      requestAnimationFrame(() =>  {
        scrollRoot.scrollTop = firstCard.offsetTop - offsetTop
      })
      return {viewableRange: {...state.viewableRange, start: Math.max(0, state.viewableRange.start - count)}}
    })
  }

  loadAfter = () => {
    const count = 20

    let scrollRoot = document.querySelector('.review__main')
    let lastChild = scrollRoot.querySelector('.verse-card:nth-last-child(2)')
    let offsetTop = lastChild.offsetTop - scrollRoot.scrollTop

    this.setState((state) => {
      requestAnimationFrame(() =>  {
        scrollRoot.scrollTop = lastChild.offsetTop - offsetTop
      })
      return {viewableRange: {...state.viewableRange, start: state.viewableRange.start + count}}
    })
  }

  render() {

    let allCards = []

    if (this.state.viewableRange.origin !== this.props.reviewRange.current) {
      this.setState((state) => ({viewableRange: {...state.viewableRange, start: this.props.reviewRange.current, origin: this.props.reviewRange.current}}))
    }

    const startRange = this.state.viewableRange.start
    // Math.min(this.state.viewableRange.start, allCards.length - this.state.viewableRange.length), this.state.viewableRange.length + this.state.viewableRange.start
    this.cards = Quran.ayaTags.slice(startRange, Math.min(startRange + this.state.viewableRange.length, Quran.ayaTags.length-1))

    const loadMoreButtonStyle = {
      transform: 'translateZ(0)',
      willChange: 'transform'
    }

    window.currentAya = this.props.reviewRange.current

    return (
        <div className="page review">
          <TopBar onBack={this.props.goToPage.bind(null, 'select-scope')} title="بازگشت" />
          {this.props.page === 'review' &&
          <main className="review__main custom-scroll">
            <div key="beforeAll" style={{textAlign: 'center'}}>
              {this.state.viewableRange.start > 0 && <RaisedButton style={{marginTop: '1em', ...loadMoreButtonStyle}} label="بارگذاری آیات قبلی" primary={true} onClick={this.loadBefore} />}
            </div>
            {this.cards}
            <div key="afterAll" style={{textAlign: 'center'}}>
              {this.state.viewableRange.start + this.state.viewableRange.length < Quran.ayaTags.length && 
              <RaisedButton style={{marginBottom: '1em', ...loadMoreButtonStyle}} label="بارگذاری آیات بعدی" primary={true} onClick={this.loadAfter} />}
            </div>
          </main>}
        </div>
    );
  }
}

export default Review;



// WEBPACK FOOTER //
// ./src/pages/Review/Review.jsx